import { talkItems } from '@/mocks/home';

export default function HotTalk() {
  return (
    <section id="talk" className="scroll-mt-20 bg-background-100/70">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-24">
        <div className="flex flex-col gap-2">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">热聊现场</p>
          <h2 className="font-heading text-2xl font-black tracking-tight md:text-4xl">吃瓜不只是围观，更是一起聊</h2>
          <p className="max-w-2xl text-sm text-foreground-700 md:text-base">
            下面的楼都还开着。进来补瓜、反瓜、再复盘，理性点，别急着上头。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2">
          {talkItems.map((t) => (
            <article key={t.topic} className="flex flex-col rounded-3xl border border-background-200 bg-background-50 p-6">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 font-heading text-base font-bold text-background-50">
                  {t.letter}
                </span>
                <div className="min-w-0">
                  <p className="truncate text-sm font-semibold text-foreground-950">{t.user}</p>
                  <p className="text-xs text-foreground-500">{t.time}</p>
                </div>
                <span className="ml-auto whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-[11px] font-semibold text-accent-800">{t.state}</span>
              </div>

              <p className="mt-4 text-sm font-medium leading-relaxed text-foreground-800 md:text-base">「{t.topic}」</p>

              <div className="mt-5 flex items-center gap-5 border-t border-background-200/70 pt-4 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-message-3-line text-sm"></i>
                  {t.replies} 回复
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-thumb-up-line text-sm"></i>
                  {t.up} 顶
                </span>
                <a href="#talk" className="ml-auto inline-flex items-center gap-1 whitespace-nowrap font-semibold text-primary-700 hover:text-primary-800">
                  加入讨论 <i className="ri-arrow-right-line text-xs"></i>
                </a>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-6 flex flex-col items-center justify-between gap-4 rounded-3xl border border-primary-200 bg-primary-100/50 px-6 py-6 md:flex-row md:px-8">
          <div className="text-center md:text-left">
            <h3 className="font-heading text-lg font-black text-foreground-950">说好的一起围观，别只蹲在我这</h3>
            <p className="mt-1 text-sm text-foreground-700">还差你这一楼。开个瓜楼、补个时间线、或者只是点个赞，都算进场。</p>
          </div>
          <a
            href="#talk"
            className="flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-chat-new-line text-base"></i>
            开个瓜楼
          </a>
        </div>
      </div>
    </section>
  );
}